module.exports = __webpack_public_path__ + "img/success.4835d0d7.svg";